module.exports = {
  label: {
    alert: 'Your session has been expired!',
    notificationStatus: 'update notification status',
    chat: 'Chat',
    buttons: {
      logout: 'Log Out'
    }
  }
};
